import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES, ISSUE_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";
import { filterIssuesWithHistoryOnAttempt } from "../../../../utils";

const getAttemptsGuid = createUUID();
const getAttemptDetailsGuid = createUUID();

const mapAttempt = (attempt) => ({
  ...attempt,
  issues: filterIssuesWithHistoryOnAttempt(attempt).map((issue) => ({
    ...issue,
    status: issue.issueResult
      ? issue.issueResult?.status ?? ISSUE_STATUSES.REPORTED
      : ISSUE_STATUSES.REPORTED,
  })),
});

export const useAttemptHistory = ({ stateManager = {} }) => {
  const [attemptList, setAttemptList] = useState([]);

  const getAttempts = async ({ assignmentId }) => {
    stateManager.abort(getAttemptsGuid);
    stateManager.run(async () => {
      const res = await taskService.attempts.getAll({
        filters: {
          assignment: { id: { type: "guid", value: assignmentId } },
        },
        sort: `createdOn desc`,
      });

      if (res.status === HTTP_STATUSES.OK) {
        /**
         * Filter out the issues that where completed in previous attempts
         */
        const attempts = res.data.map(mapAttempt);

        setAttemptList(attempts);
      } else {
        setAttemptList([]);
      }
    }, getAttemptsGuid);
  };

  const getAttemptDetails = async (attemptId) => {
    stateManager.abort(getAttemptDetailsGuid);

    return stateManager.run(async () => {
      const res = await taskService.attempts.get(attemptId);

      if (res.status !== HTTP_STATUSES.OK) {
        return null;
      }

      return mapAttempt(res.data);
    }, getAttemptDetailsGuid);
  };

  return {
    getAttempts,
    getAttemptDetails,
    attemptList,
  };
};
